export default "__VITE_ASSET__C0j1cMxa__"